import React, {useEffect, useRef, useState} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logo from '../Headers/assets/new-logo.svg';
import '../Shared/styles/collectionNavDropdown.css';
import './styles/Footer.css';
import { SignInForCollectionNavModal } from '../Shared/components/SignInPromptModals.jsx';
import telegram from '../Shared/assets/social/telegram.svg';
import facebook from '../Shared/assets/social/facebook.svg';
import instagram from '../Shared/assets/social/instagram.svg';
import twitter from '../Shared/assets/social/twitter.svg';
import whatsApp from '../Shared/assets/social/whatsApp.svg';
import { FACEBOOK_URL, INSTAGRAM_URL, TELEGRAM_BOT_URL, TWITTER_URL, WHATSAPP_URL } from '../Shared/constants/socialLinks.js';
import { CONTACT_EMAIL, CONTACT_MAILTO, LEGAL_NAME } from '../Shared/constants/brand.js';
import { openPrivacyChoices } from '../Shared/utils/cookieConsent.js';

function FooterRouteLink({ fullPageNavigation, to, children, ...props }) {
    if (fullPageNavigation) {
        return (
            <a href={to} {...props}>
                {children}
            </a>
        );
    }

    return (
        <Link to={to} {...props}>
            {children}
        </Link>
    );
}

export default function Footer({ fullPageNavigation = false }) {

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [isMyCollectionOpened, setIsMyCollectionOpened] = useState(false);
    const [isNeedSingInModalOpened, setIsNeedSingInModalOpened] = useState(false);
    const documentClickListener = useRef(null)
    const [mail, setMail] = useState('')

    useEffect(() => {
        const storedEmail = localStorage.getItem('email');
        if (storedEmail) {
            setMail(storedEmail);
        }
    }, []);

    useEffect(() => {
        documentClickListener.current = (e) => {
            setIsMyCollectionOpened(false);
            document.removeEventListener('click', documentClickListener.current);
        }
    }, [])

    const openMyColection = () => {
        setTimeout(() => {
            if (!isMyCollectionOpened) {
                document.addEventListener('click', documentClickListener.current);
            }
        })
        setIsMyCollectionOpened(!isMyCollectionOpened);

    }

    function onSavedJewelryClick(e) {
        setIsMyCollectionOpened(false);
        if (!isAuthenticated) {
            e.preventDefault();
            setIsNeedSingInModalOpened(true);
            return;
        }
    }

    function onFollowedBrandsClick(e) {
        setIsMyCollectionOpened(false);
        if (!isAuthenticated) {
            e.preventDefault();
            setIsNeedSingInModalOpened(true);
            return;
        }
    }

    return (
        <>
        <footer className="footer">
            <div className={"content"}>
                <div className="footer__single-block">
                    <div className="footer__blocks">
                        <div className="footer__logo-block">
                            <img src={logo} alt="logo" width={122} height={48} />
                        </div>
                        <div className="footer__block footers__links">
                            <p>QUICK LINKS</p>
                            <a href={'/'}>Home</a>
                            <FooterRouteLink fullPageNavigation={fullPageNavigation} to={'/upcoming-lots'}>Upcoming Lots</FooterRouteLink>
                            <FooterRouteLink fullPageNavigation={fullPageNavigation} to={'/past-lots'}>Auction Results</FooterRouteLink>
                            <FooterRouteLink fullPageNavigation={fullPageNavigation} to={'/pricing'}>Pricing</FooterRouteLink>
                            <FooterRouteLink fullPageNavigation={fullPageNavigation} to={'/guides'}>Guides</FooterRouteLink>
                            <FooterRouteLink fullPageNavigation={fullPageNavigation} to={'/about-us'}>About Us</FooterRouteLink>
                            <div onClick={openMyColection}>
                                <span className={'header-link__my-collection footer-link__my-collection'}>
                                    <span className={'header-link__my-collection-trigger' + (isMyCollectionOpened ? ' is-open' : '')}>
                                        <p>My Collection</p>
                                        <svg className="closed" width="16" height="17" viewBox="0 0 16 17" fill="none" strokeOpacity="0.6" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 6.5L8 10.5L12 6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <svg className="opened" width="16" height="17" viewBox="0 0 16 17" fill="none" strokeOpacity="0.6" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 6.5L8 10.5L12 6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </span>
                                    <div className={"collection__menu header__links" + (isMyCollectionOpened ? ' visible' : '')}>
                                        <FooterRouteLink fullPageNavigation={fullPageNavigation} to="/my-collection" rel="nofollow" onClick={onSavedJewelryClick}>Saved Jewelry</FooterRouteLink>
                                        <div className="divider"></div>
                                        <FooterRouteLink fullPageNavigation={fullPageNavigation} to="/followed-brands" rel="nofollow" onClick={onFollowedBrandsClick}>Followed Brands</FooterRouteLink>
                                    </div>
                                </span>
                            </div>
                            <a href={'/contact-us'}>Contact us</a>
                        </div>
                        <div className="footer__block footers__links">
                            <p>INFORMATION</p>
                            <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
                            <a href={"/privacy-policy"}>Privacy Policy</a>
                            <a href={"/gdpr"}>GDPR</a>
                            <a href={"/terms-condition"}>Terms of Use</a>
                            <button type="button" className="footer__privacy-choices" onClick={openPrivacyChoices}>
                                Your Privacy Choices
                            </button>
                            <a href={"/faq"}>FAQs</a>
                        </div>
                        <div className="footer__block newsletter__block">
                            <p>NEWSLETTER</p>
                            <p>Subscribe for auction updates</p>
                            <div className={"input-wrapper"}>
                                <input
                                    type="email"
                                    id="footer-newsletter-email"
                                    name="newsletter-email"
                                    placeholder="Email address"
                                    autoComplete="email"
                                    value={mail}
                                    onChange={(e) => {setMail(e.target.value)}}
                                />
                                <button>Subscribe</button>
                            </div>
                            <div className={"social-media-wrapper"}>
                                <a href={TELEGRAM_BOT_URL}>
                                    <img src={telegram} alt="telegram"/>
                                </a>
                                <a href={FACEBOOK_URL}>
                                    <img src={facebook} alt="facebook"/>
                                </a>
                                <a href={INSTAGRAM_URL}>
                                    <img src={instagram} alt="instagram"/>
                                </a>
                                <a href={TWITTER_URL}>
                                    <img src={twitter} alt="twitter"/>
                                </a>
                                <a href={WHATSAPP_URL}>
                                    <img src={whatsApp} alt="whatsApp"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="rights">© {new Date().getFullYear()} {LEGAL_NAME}. All rights reserved.</p>
            </div>
        </footer>
        <SignInForCollectionNavModal isOpened={isNeedSingInModalOpened} setIsOpened={setIsNeedSingInModalOpened}/>
        </>
    );
}

Footer.propTypes = {
    fullPageNavigation: PropTypes.bool,
};